module.exports = __webpack_public_path__ + "img/041-coffin.d3ce4eee.png";